import {takeEvery} from 'redux-saga/effects'

import {
  GET_ATTENDANCE_STATUS_BUNK,
  GET_ATTENDANCE_STATUS_PRESENT,
  GET_DUPLICATE_ATTENDANCE,
  GET_DUPLICATE_ATTENDANCE_DATE,
} from '../../../Actions/Diagnose/ActionTypes/ApiActionTypes'
import fetchData from '../../SagaHelper'

export default function* diagnoseSaga() {
  yield takeEvery(GET_DUPLICATE_ATTENDANCE, fetchData)
  yield takeEvery(GET_DUPLICATE_ATTENDANCE_DATE, fetchData)
  yield takeEvery(GET_ATTENDANCE_STATUS_PRESENT, fetchData)
  yield takeEvery(GET_ATTENDANCE_STATUS_BUNK, fetchData)
}
